export const NEWSLETTER_SUBSCRIBE = 'NEWSLETTER_SUBSCRIBE'
export const NEWSLETTER_UNSUBSCRIBE = 'NEWSLETTER_UNSUBSCRIBE'
export const SET_EMAIL = 'SET_EMAIL'
export const SET_EVENT_REMINDER_SUBSCRIPTIONS = 'SET_EVENT_REMINDER_SUBSCRIPTIONS'
